module.exports = __webpack_public_path__ + "media/assets/images/conference_room_forms/reception-form-new-4cce8894c8b066bbb5048409e074962e.gif";